import { ThemeProvider, CssBaseline } from "@mui/material";
import React, { useState, useMemo, useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { lightTheme, darkTheme } from "./theme";
import { GoldRateProvider } from "./context/GoldRateContext";

// Create a theme context
export const ThemeContext = React.createContext({
  toggleTheme: () => {},
  isDarkMode: false,
});

function App() {
  // Initialize theme from localStorage or system preference
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("theme-mode");
    if (savedMode) {
      return savedMode === "dark";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  // Listen for system theme changes (only if user hasn't set preference)
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e) => {
      if (!localStorage.getItem("theme-mode")) {
        setIsDarkMode(e.matches);
      }
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  // Toggle theme and save to localStorage
  const toggleTheme = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem("theme-mode", newMode ? "dark" : "light");
      return newMode;
    });
  };

  // Memoize theme to prevent unnecessary re-renders
  const theme = useMemo(
    () => (isDarkMode ? darkTheme : lightTheme),
    [isDarkMode]
  );

  return (
    <ThemeContext.Provider value={{ toggleTheme, isDarkMode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GoldRateProvider>
          {" "}
          {/* Add this wrapper */}
          <AppRoutes />
        </GoldRateProvider>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export default App;
